/** Pure helpers for the share buttons, kept DOM-light so they can be unit tested. */

interface LocationLike {
  origin: string
  pathname: string
}

/**
 * The link a share button hands out: the page you are on, without query string or hash, so
 * tracking params and in-page anchors never get passed along.
 *
 * Deliberately not the canonical URL. That always names the production domain, so a link shared
 * from a preview host would point somewhere the reader was not looking at.
 */
export function getShareUrl(location: LocationLike): string {
  return `${location.origin}${location.pathname}`
}

interface ShareEnvironment {
  /** `typeof navigator.share === 'function'` */
  canShare: boolean
  /** `matchMedia('(pointer: coarse)').matches`: the primary input is touch */
  coarsePointer: boolean
}

/**
 * Desktop Safari, Chrome and Edge also implement `navigator.share`, but there the expected
 * behaviour is a plain copy. Only touch-first devices (phones, tablets) get the native sheet.
 */
export function shouldUseNativeShare({ canShare, coarsePointer }: ShareEnvironment): boolean {
  return canShare && coarsePointer
}
